import axios from 'axios';
import { apiUrl } from './apiUrl';
axios.defaults.headers.common['Authorization'] = localStorage.getItem('loginToken') || '';

export const getCarsIn = () =>
    axios.get(`${apiUrl}/carsIn`)

export const getCarsOut = () =>
    axios.get(`${apiUrl}/carsOut`)

export const markArrived = _id =>
    axios.put(`${apiUrl}/markArrived`, { _id })

export const markReturned = _id =>
    axios.put(`${apiUrl}/markReturned`, { _id })

export const getFlights = () =>
    axios.get(`${apiUrl}/flights`)

// export const markArrived = () =>
//     axios.get(`${apiUrl}/dashboardstats`)

// export const markReturned = () =>
//     axios.get(`${apiUrl}/dashboardstats`)


// WEBPACK FOOTER //
// ./src/baseparking-api/Processing.js